var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { GenericAdapter } from './GenericAdapter';
import { eventToTuple } from '../utils';
import { CONSENT } from '../types/consent';
var OptimizelyAdapter = /** @class */ (function (_super) {
    __extends(OptimizelyAdapter, _super);
    function OptimizelyAdapter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isReady = false;
        _this.consent = CONSENT.FUNCTIONAL;
        return _this;
    }
    Object.defineProperty(OptimizelyAdapter.prototype, "context", {
        get: function () {
            return this.userCtx;
        },
        enumerable: false,
        configurable: true
    });
    OptimizelyAdapter.prototype.configure = function (config) {
        if (config.userContext) {
            this.userCtx = config.userContext;
        }
        this.broadcastReady();
    };
    OptimizelyAdapter.prototype._convertPayload = function (obj) {
        // NOTE: Casting the return values to `EventTags` because there is a bug in Optimizely SDK
        // where the properties on EventTags are wrong.
        // More info: https://github.com/optimizely/javascript-sdk/pull/1040
        if (!Object.keys(obj !== null && obj !== void 0 ? obj : {}).length) {
            return {
                $opt_event_properties: {}
            };
        }
        var _a = obj !== null && obj !== void 0 ? obj : {}, revenue = _a.revenue, value = _a.value, properties = __rest(_a, ["revenue", "value"]);
        return __assign(__assign(__assign({}, (revenue ? { revenue: revenue } : {})), (value ? { value: value } : {})), { $opt_event_properties: properties });
    };
    OptimizelyAdapter.prototype.track = function (obj) {
        var _a;
        var _b = eventToTuple(obj), eventName = _b[0], payload = _b[1];
        (_a = this.userCtx) === null || _a === void 0 ? void 0 : _a.trackEvent(eventName, this._convertPayload(payload));
    };
    return OptimizelyAdapter;
}(GenericAdapter));
export var Optimizely = new OptimizelyAdapter();
